import React from 'react';
import PropTypes from 'prop-types';
import { Menu, MenuItem, H4 } from '@aurora/widgets-react';
import Logo from './Logo';

import './navigation.css';

const Navigation = () => {
  return (
    <div className="navContainer">
      <div className="navigation">
        <Logo />
        <H4>SMHI Real Estate API Docs</H4>
      </div>
      <nav className="navigation">
        <Menu>
          <MenuItem to="/" content="Home" />
          <MenuItem to="/authentication" content="Authentication" />
          <MenuItem to="/datarequests" content="Data Requests" />
          <MenuItem to="/products" content="Products" />
          <MenuItem to="/parameters" content="Parameters" />
          <MenuItem to="/codeexamples" content="Code Examples" />
          <MenuItem to="/servicelevel" content="Service Level" />
        </Menu>
      </nav>
    </div>
  );
};

Navigation.propTypes = {
  pages: PropTypes.array,
};

export default Navigation;
